// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

/**
 * Note: In order to support Swift, we can't have a fixed
 * size for the UUID, so instead we have to simply 
 * enumerate all the fields.
 */
export class UuidInnerBuf {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):UuidInnerBuf {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

key0():number {
  return this.bb!.readUint8(this.bb_pos);
}

key1():number {
  return this.bb!.readUint8(this.bb_pos + 1);
}

key2():number {
  return this.bb!.readUint8(this.bb_pos + 2);
}

key3():number {
  return this.bb!.readUint8(this.bb_pos + 3);
}

key4():number {
  return this.bb!.readUint8(this.bb_pos + 4);
}

key5():number {
  return this.bb!.readUint8(this.bb_pos + 5);
}

key6():number {
  return this.bb!.readUint8(this.bb_pos + 6);
}

key7():number {
  return this.bb!.readUint8(this.bb_pos + 7);
}

key8():number {
  return this.bb!.readUint8(this.bb_pos + 8);
}

key9():number {
  return this.bb!.readUint8(this.bb_pos + 9);
}

key10():number {
  return this.bb!.readUint8(this.bb_pos + 10);
}

key11():number {
  return this.bb!.readUint8(this.bb_pos + 11);
}

key12():number {
  return this.bb!.readUint8(this.bb_pos + 12);
}

key13():number {
  return this.bb!.readUint8(this.bb_pos + 13);
}

key14():number {
  return this.bb!.readUint8(this.bb_pos + 14);
}

key15():number {
  return this.bb!.readUint8(this.bb_pos + 15);
}

static sizeOf():number {
  return 16;
}

static createUuidInnerBuf(builder:flatbuffers.Builder, key0: number, key1: number, key2: number, key3: number, key4: number, key5: number, key6: number, key7: number, key8: number, key9: number, key10: number, key11: number, key12: number, key13: number, key14: number, key15: number):flatbuffers.Offset {
  builder.prep(1, 16);
  builder.writeInt8(key15);
  builder.writeInt8(key14);
  builder.writeInt8(key13);
  builder.writeInt8(key12);
  builder.writeInt8(key11);
  builder.writeInt8(key10);
  builder.writeInt8(key9);
  builder.writeInt8(key8);
  builder.writeInt8(key7);
  builder.writeInt8(key6);
  builder.writeInt8(key5);
  builder.writeInt8(key4);
  builder.writeInt8(key3);
  builder.writeInt8(key2);
  builder.writeInt8(key1);
  builder.writeInt8(key0);
  return builder.offset();
}

}
